import { takeEvery } from 'redux-saga';
import { all, call, put, select } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* getFilter({ payload }) {
    const inputs = yield select(state => state.catalog.inputs);
    const filters = inputs.reduce((filters, input) => {
        let values = [];
        input.count = 0;

        input.items.forEach(item => {
            if (item.checked) {
                input.count++;
                if (item.value.match(/,/)) {
                    item.value.split(',').forEach(v => {
                        values.push(v);
                    });
                } else {
                    values.push(item.value);
                }
            }
        });

        if (values.length) {
            filters[input.key] = values;
        }

        return filters;
    }, {});

    if (payload && payload.search) {
        filters.search = payload.search;
    }

    if (payload && payload.price) {
        filters.price = payload.price;
    }

    yield put({
        type: 'catalog:filter',
        payload: {
            filters: filters,
            inputs: inputs,
        },
    });

    const filters_array = [];
    if (filters.category) {
        filters_array.push('category=' + filters.category.join(',').replace(/^,/, ''));
    }

    if (filters.modality) {
        filters_array.push('modality=' + filters.modality.join(',').replace(/^,/, ''));
    }

    if (filters.search) {
        filters_array.push('search=' + encodeURIComponent(filters.search));
    }

    if (filters.price) {
        filters_array.push('price=' + encodeURIComponent(filters.price));
    }

    const filter_string = filters_array.join('&');
    const products = yield select(state => state.catalog.products);
    let should_fire_event = false;

    yield all(
        products.map((product, index) => {
            window.ga('ec:addImpression', {
                id: product.code,
                name: product.product_name,
                list: 'Catalog' + (filter_string ? ' - ' + filter_string : ''),
                position: index,
            });

            if (index % 50 === 0 && should_fire_event) {
                should_fire_event = false;
                return call(catalogImpression, filter_string);
            }
            should_fire_event = true;
            return call(() => {});

        })
    );

    if (should_fire_event) {
        yield call(catalogImpression, filter_string);
    }
}

function* catalogImpression(filter_string) {
    const logged_in = yield select(state => state.user.logged_in);
    const action = logged_in ? 'LI Impression' : 'LO Impression';

    yield put({
        type: 'ga:event',
        payload: [
            'Catalog',
            action,
            filter_string || 'No Filter',
        ],
    });
}

export function* getPrices({ payload }) {
    const products = yield select(state => state.catalog.products);

    yield products.map((product, i) => call(getPrice, product, i));

    yield put({
        type: 'catalog:get-filter',
        payload: payload,
    });
}

function* getPrice(product, i) {
    const do_not_lookup = [
        'karma-coin-package',
        'daily-horoscope-iphone-app',
    ];


    let products = yield select(state => state.catalog.products);
    let kc = 0;
    let on_sale = true;

    if (!do_not_lookup.includes(product.code)) {
        const [ api, params ] = yield all([
            select(state => state.api.host),
            select(state => state.api.params),
        ]);

        try {
            const price = yield call(getJSON, `${api}/commerce/price/${product.code}`,  params);

            if (price && price.kc && price.kc.current && price.kc.original) {
                kc = price.kc.current;
                on_sale = price.kc.current > price.kc.original;
            }
        } catch (e) {
            return;
        }
    }

    products[i].kc = kc;
    products[i].on_sale = on_sale;

    yield put({
        type: 'catalog:update',
        payload: {
            products: products,
        },
    });
}

export function* root() {
    yield* [
        takeEvery('catalog:get-filter', getFilter),
        takeEvery('catalog:get-prices', getPrices),
    ];
}



// WEBPACK FOOTER //
// ./app/sagas/catalog.js